import { useEffect, useState } from 'react';
import Header from '../../../components/dashboard/Header';
import ResultFilterBar from '../../../components/general/ResultFilterBar';
import Tableform from '../../../components/general/Tableform';
import { API } from '../../../api';
import { errorToast, successToast } from '../../../hooks/useToast';
import Loader from '../../../components/general/Loader';
// import { categoriescolumn } from '../../../data/categoriescolumn ';
import { promoColumns } from '../../../data/promoColumns';

const PromoComponent = () => {
  const [itemPerPage, setitemPerPage] = useState(10);
  const [filterdata, setfilterdata] = useState();
  const [searchFilter, setSearchFilter] = useState(null);

  const [loading, setLoading] = useState(true);
  const [allcategories, setAllCategories] = useState(null);

  const getData = async () => {
    try {
      const response = await API.getPromo();
      setAllCategories(response?.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      errorToast(error, 'Can not fetch data');
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await API.deletePromo(id);
      successToast('promo deleted Successfuly');
      setAllCategories((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      errorToast(err, "Can't delete Promo");
    }
  };

  return (
    <div className="page-area mt-10">
      <Header
        pagetitle={'Promo Codes'}
        previous={'Dashboard'}
        currentpage={'Promo Codes'}
        btntext={'Add Promo Code'}
        btnlink={'/dashboard/store/promo/add-promo'}
      />
      <div className="page-comp bg-white mt-10 rounded-xl px-8 py-8">
        <ResultFilterBar
          setitemPerPage={setitemPerPage}
          setfilterdata={setAllCategories}
          filterdata={allcategories}
          setSearchFilter={setSearchFilter}
        />
        {loading ? (
          <Loader />
        ) : (
          <>
            {allcategories && (
              <Tableform
                filterdata={allcategories}
                tablecolumns={promoColumns}
                itemPerPage={itemPerPage}
                searchFilter={searchFilter}
                pagename={'edit-promo'}
                preview={false}
                // handleDelete={handleDelete}
                // isDelete={true}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PromoComponent;
